<template>
    <div style="padding-top: 50px;">
        <div class="columns">
            <div class="column is-one-fifth">
                <profit-side-bar></profit-side-bar>
            </div>
            <div class="column">
                <div class="columns">
                    <div class="column has-text-centered">
                        <profit-total-sales></profit-total-sales>
                    </div>
                    <div class="column has-text-centered">
                        <profit-total-costs></profit-total-costs>
                    </div>
                    <div class="column has-text-centered">
                        <profit-total-profit></profit-total-profit>
                    </div>
                    <div class="column has-text-centered">
                        <profit-ratio></profit-ratio>
                    </div>
                </div>
                <div class="columns">
                    <div class="column" v-if="manager">
                       <profit-manager-goal></profit-manager-goal>
                    </div>
                    <div class="column" v-else>
                        <p class="has-text-grey-light">Please select Sales Person to assign goal.</p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <profit-invoices-table></profit-invoices-table>
                    </div>
                </div>
                <div class="columns">
                    <profit-invoice-table-pagination></profit-invoice-table-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProfitSideBar from './ProfitSideBar'
    import ProfitTotalSales from './ProfitTotalSales'
    import ProfitTotalCosts from './ProfitTotalCosts'
    import ProfitTotalProfit from './ProfitTotalProfit'
    import ProfitRatio from './ProfitRatio'
    import ProfitInvoicesTable from './ProfitInvoicesTable'
    import ProfitInvoiceTablePagination from './ProfitInvoiceTablePagination'
    import ProfitManagerGoal from './ProfitManagerGoal'
    export default {
        components: {
            ProfitSideBar,
            ProfitTotalSales,
            ProfitTotalCosts,
            ProfitTotalProfit,
            ProfitRatio,
            ProfitInvoicesTable,
            ProfitInvoiceTablePagination,
            ProfitManagerGoal,
        },
        computed: {
            manager() {
                return this.$store.getters.getProfitSectionSelectedManager
            }
        },
        mounted() {
            this.$store.dispatch('fetchProfitSectionDefaultData')
        },
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Profit/ProfitList.vue